import { FormattedMessage } from 'react-intl';
import { withAccess } from 'hooks/rbac/withAccess';

export const RbacFormattedMessage = withAccess(FormattedMessage);
